import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { colors, Divider } from "@material-ui/core";
import {
  useStylesTF,
  useStylesTD,
  useStylesContainers,
  useStylesHed,
} from "../../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
import { useStylesLbl } from "../../../St/Reports/UseStyle";

export default function EmployeesSalaryData(props) {
  const { object, data, onChange } = props;
  const clasTF = useStylesTF();
  const clasTD = useStylesTD();
  const clsConts = useStylesContainers();
  const { t } = useTranslation(["forms", "translation"]);

  let all_salary=Number(object?.salary_basic)+Number(object?.salary_add)+Number(object?.house)+
  Number(object?.food)+Number(object?.travel)+Number(object?.medical)+Number(object?.salary_other);
  useEffect(()=>{
    console.log("the dta is ", object)
  })
  const onChangeData = (prop) => (event) => {
    onChange(event, { name: prop, value: event.target.value });
  };
  const claslbl = useStylesLbl();

  return (
    <Grid container lg={12} md={12}>
      <Grid item container spacing={1} xs={12} className={[clsConts.rootup]}>
        <React.Fragment>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"salary_basic"}
              label={t("basic-salary")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              style={{ backgroundColor: colors.blueGrey[50]  }}
              InputProps={{ className: claslbl.clrBlackLblS}}
              type="number"
              name={"salary_basic"}
              value={object?.salary_basic?? ""}
              onChange={onChangeData("salary_basic")}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"house"}
              label={t("housing")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="text"
              name={"house"}
              value={object.house?? ""}
              onChange={onChangeData("house")}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"food"}
              label={t("food")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="number"
              name={"food"}
              value={object?.food?? ""}
              onChange={onChangeData("food")}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"travel"}
              label={t("travel")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="number"
              name={"travel"}
              value={object.travel?? ""}
              onChange={onChangeData("travel")}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"medical"}
              label={t("medical-insurance")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="text"
              name={"medical"}
              value={object.medical?? ""}
              onChange={onChangeData("medical")}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"salary_add"}
              label={t("fixed-bonus")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="text"
              name={"salary_add"}
              value={object.salary_add?? ""}
              onChange={onChangeData("salary_add")}
            />
          </Grid>


          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"salary_other"}
              label={t("other")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS }}
              type="text"
              name={"salary_other"}
              value={object.salary_other?? ""}
              onChange={onChangeData("salary_other")}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Divider style={{ margin: "10px" }} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id={"tax_additional_address_no"}
              label={t("total-salary-dues")}
              InputLabelProps={{className:claslbl.clrBlackLblS}}
              InputProps={{ className:claslbl.clrBlackLblS,readOnly:true }}
              type="text"
              name={"tax_additional_address_no"}
              value={parseFloat(all_salary).toFixed(2)}
            />
          </Grid>

        </React.Fragment>
      </Grid>
    </Grid>
  );
}
